import React, { useEffect, useState } from 'react'
import { fetchSingleDeviceTodayData } from '../../redux/action/totalData'
import TemperatureDetailContainer from '../../SystemValues/Temperature'
import OnlineStatusDetailContainer from '../../SystemValues/OnlineStatus'
import ACStatusDetailContainer from '../../SystemValues/ACStatus'
import ApplianceHealthDetailContainer from '../../SystemValues/ApplianceHealth'
import TotalUnitsConsumedDetailContainer from '../../SystemValues/TotalUnitsConsumed'
import UnitSavedDetailContainer from '../../SystemValues/UnitSaved'
import MoneySpentDetailContainer from '../../SystemValues/MoneySpent'
import MoneySavedDetailContainer from '../../SystemValues/MoneySaved'
import MoneySavingDetailContainer from '../../SystemValues/MoneySaving'
import UnitSavingsDetailContainer from '../../SystemValues/UnitSavings'
import SavingsDetailContainer from '../../SystemValues/Saving'
import CarbonSavedDetailContainer from '../../SystemValues/CarbonSaved'
import { calculateGlobalData } from '../../common/function'
import { Col, Row } from 'react-bootstrap'
import styles from '../../MainPage/common/styles'
import { de } from 'date-fns/locale'
import VoltageDetailContainer from '../../SystemValues/Voltage'
import CurrentDetailContainer from '../../SystemValues/Current'
import PowerFactorDetailContainer from '../../SystemValues/PowerFactor'
import PowerDetailContainer from '../../SystemValues/Power'
import UnitConsumedDetailContainer from '../../SystemValues/UnitConsumed'
import { useNavigate } from 'react-router-dom'
import { ChevronBarRight, ChevronRight } from 'react-bootstrap-icons'

// Devices configured with a maximumUnitPerHour report their savings as globalSaving, the
// rest as plain saved units. Shared by the card and by the total reported to the dashboard
// so the two can never drift apart.
const savedUnitsOf = (device, values) =>
  device?.graphParameters?.saving?.maximumUnitPerHour !== undefined
    ? values.globalSaving
    : values.globalUnitSaved;

const EnergiSync = ({ device, ppu, houseId, systemValuesComponent, onTotals }) => {
  const navigate = useNavigate()
  const [systemValuesData, setSystemValuesData] = useState({
    globalMoneySaved: 0,
    globalMoneySpent: 0,
    globalUnitSaved: 0,
    globalUnitConsumed: 0,
    globalUnitSavingPercentge: 0,
    globalSaving: 0,
    time: "12:00 AM",
  });
  const [selectedDeviceDetails, setSelectedDeviceDetails] = useState({});
  const [phaseLoadLogs, setPhaseLoadLogs] = useState({});
  const [graphData, setGraphData] = useState({
    moneySaved: [],
    moneySpent: [],
    online: [],
    carbonConsumed: [],
    carbonSaved: [],
    unitConsumed: [],
    unitSaved: [],
    saving: [],
  });
  useEffect(() => {
    if (device) {
      fetchSingleDeviceTodayData(device.deviceId).then((res) => {
        setSelectedDeviceDetails(res)
      })
    }
  }, [])
  useEffect(() => {
    if (selectedDeviceDetails) {
      const { systemValues, graphData, phaseLoadLogs } = calculateGlobalData(
        [selectedDeviceDetails],
        ppu,
        device
      );

      let saving = []
      if (device?.graphParameters?.saving !== undefined && device?.graphParameters?.saving?.maximumUnitPerHour !== undefined) {
        for (let dataConsume of graphData.carbonConsumed) {
          saving.push(dataConsume)
        }
      }

      setPhaseLoadLogs({ ...phaseLoadLogs });
      setSystemValuesData({ ...systemValues });
      setGraphData({ ...graphData, saving });

      // Reported upward so the dashboard header can total every meter it shows.
      const unitsSaved = savedUnitsOf(device, systemValues);
      const unitsConsumed = systemValues.globalUnitConsumed;
      onTotals?.(device?.deviceId, {
        unitsSaved: isNaN(unitsSaved) ? 0 : unitsSaved,
        unitsConsumed: isNaN(unitsConsumed) ? 0 : unitsConsumed,
      });
    }
  }, [selectedDeviceDetails])
  const systemValuesContainerComponents = {
    temperature: (
      <TemperatureDetailContainer
        key={`temperature-${device?.deviceId}`}
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={[selectedDeviceDetails]}
      />
    ),
    onlineStatus: (
      <OnlineStatusDetailContainer
        key={`onlineStatus-${device?.deviceId}`}
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={[selectedDeviceDetails]}
      />
    ),
    ACStatus: (
      <ACStatusDetailContainer
        key={`ACStatus-${device?.deviceId}`}
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={[selectedDeviceDetails]}
        selectedDate={new Date().toDateString()}
        deviceId={device?.deviceId}
      />
    ),
    applianceHealth: (
      <ApplianceHealthDetailContainer
        key={`applianceHealth-${device?.deviceId}`}
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={[selectedDeviceDetails]}
      />
    ),
    unitConsumed: (
      <TotalUnitsConsumedDetailContainer
        key={`unitConsumed-${device?.deviceId}`}
        time={systemValuesData.time}
        unitsConsumed={systemValuesData.globalUnitConsumed}
        
      />
    ),
    unitSaved: (
      <UnitSavedDetailContainer
        key={`unitSaved-${device?.deviceId}`}
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={[selectedDeviceDetails]}
        unitsSaved={savedUnitsOf(device, systemValuesData)}
      />
    ),
    moneySpent: (
      <MoneySpentDetailContainer
        key={`moneySpent-${device?.deviceId}`}
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={[selectedDeviceDetails]}
        moneySpent={systemValuesData.globalMoneySpent}
      />
    ),
    moneySaved: (
      <MoneySavedDetailContainer
        key={`moneySaved-${device?.deviceId}`}
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={[selectedDeviceDetails]}
        moneySaved={systemValuesData.globalMoneySaved}
      />
    ),
    moneySaving: (
      <MoneySavingDetailContainer
        key={`moneySaving-${device?.deviceId}`}
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={[selectedDeviceDetails]}
        moneySaved={systemValuesData.globalMoneySaved}
        moneySpent={systemValuesData.globalMoneySpent}
      />
    ),
    unitSaving: (
      <UnitSavingsDetailContainer
        key={`unitSaving-${device?.deviceId}`}
        time={systemValuesData.time}
        unitsSaved={systemValuesData.globalUnitSaved}
        unitsConsumed={systemValuesData.globalUnitConsumed}
      />
    ),
    saving: (
      <SavingsDetailContainer
        key={`saving-${device?.deviceId}`}
        time={systemValuesData.time}
        unitsSaved={systemValuesData.globalSaving}
        unitsConsumed={systemValuesData.globalUnitConsumed}
      />
    ),
    carbonSaving: (
      <CarbonSavedDetailContainer
        key={`carbonSaving-${device?.deviceId}`}
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={[selectedDeviceDetails]}
        carbonSavedData={graphData.carbonSaved}
        carbonConsumedData={graphData.carbonConsumed}
      />
    ),
  };
  return (
    <div
      key={device?.deviceId}
      style={{
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
        padding: "20px",
        marginTop: "20px",
        borderRadius: "10px",
        backgroundColor: 'rgb(243 244 244)',
        position: 'relative'
      }}>
      <ChevronRight
        style={{ position: 'absolute', right: '20px', top: '20px', fontSize: '20px', fontWeight: '800' }}
        onClick={() => navigate(`/dashboard/${device.type}/${houseId}/${device.roomId}/${device.deviceId}`)}
      />
      <div>
        <h5 style={{ textAlign: 'left' }}> {device?.name ? `${device?.name} - ` : ""}
          {device.deviceId}</h5>
      </div>
      <Row
        style={{ ...styles.smallBoxContainer }}
        className="row g-2"
      >
        {Object.keys(systemValuesContainerComponents).filter(value => systemValuesComponent.includes(value)).map((key) =>
          <Col md={6} sm={12} key={key}>
            {React.cloneElement(systemValuesContainerComponents[key], { key: `${key}-${device?.deviceId}` })}
          </Col>
        )}
      </Row>
    </div>
  )
}

export default EnergiSync